import { del, get, set } from 'idb-keyval'

export interface AssetRecord {
  fileName: string
  mime: string
  bytes: ArrayBuffer
}

export const MAX_ASSET_BYTES = 40 * 1024 * 1024

const memory = new Map<string, AssetRecord>()
const key = (id: string) => `megaspace:asset:${id}`

export function putAssetMemory(id: string, rec: AssetRecord) {
  memory.set(id, rec)
}

export async function addAsset(id: string, rec: AssetRecord) {
  memory.set(id, rec)
  try {
    await set(key(id), rec)
  } catch {
    /* storage may be full or blocked; the asset still lives in memory for this session */
  }
}

export async function getAsset(id: string): Promise<AssetRecord | undefined> {
  const hit = memory.get(id)
  if (hit) return hit
  try {
    const rec = (await get(key(id))) as AssetRecord | undefined
    if (rec) memory.set(id, rec)
    return rec
  } catch {
    return undefined
  }
}

export function memoryAssets(): ReadonlyMap<string, AssetRecord> {
  return memory
}

/** Drop stored assets that no scene references any more. */
export async function pruneAssets(keep: Set<string>, known: Iterable<string>) {
  for (const id of known) {
    if (keep.has(id)) continue
    memory.delete(id)
    try {
      await del(key(id))
    } catch {
      /* ignore */
    }
  }
}

export function extensionFor(fileName: string, mime: string): string {
  const m = /\.([a-z0-9]{1,5})$/i.exec(fileName)
  if (m) return m[1]!.toLowerCase()
  if (mime.includes('wav')) return 'wav'
  if (mime.includes('ogg')) return 'ogg'
  if (mime.includes('mpeg')) return 'mp3'
  return 'bin'
}
